import CourseInfoContainer from './CourseInfoContainer';
export default CourseInfoContainer;
